import React, { useState } from 'react'
import { firestore } from '../../../../firebase';

function AddDetail() {

    const [description, setDescription] = useState("");
    const [image, setImage] = useState("https://firebasestorage.googleapis.com/v0/b/backend-footgrail.appspot.com/o/gallery%2Fthe-ball-stadion-football-the-pitch-47730-pixabay.jpeg?alt=media&token=36484b11-d844-4670-965e-c25c0e16ed1b");
    const [link, setLink] = useState("");
    const [subtitle, setSubtitle] = useState("");
    const [title, setTitle] = useState("");

    const [error, setError] = useState("");
    const [message, setMessage] = useState("");

    async function submitHandler(e) {
        e.preventDefault();
        try {
            const detailsRef = firestore.collection("site_details").doc("X0LJ5z6LWL0qF8AluQLA").collection("home_cards");
            
            const data = {
                title, 
                description,
                image,
                link,
                subtitle,

            }
            detailsRef.add(data);
            setMessage("Lagt til")
        } catch (error) {
            setError("Kunne ikke legge til");
        }
        
    }

    return (
        <form onSubmit={submitHandler}>
            <label>Tittel</label>
            <input className="form-control mb-2" value={title} onChange={e => setTitle(e.target.value)} placeholder="Tittel" />

            <label>Beskrivelse</label>
            <input className="form-control mb-2" value={description} onChange={e => setDescription(e.target.value)} placeholder="Beskrivelse" />

            <label>Lenke</label>
            <input className="form-control mb-2" value={link} onChange={e => setLink(e.target.value)} placeholder="Link" />

            <label>Subtittel</label>
            <input className="form-control mb-2" value={subtitle} onChange={e => setSubtitle(e.target.value)} placeholder="Subtittel" />

            {message && <div className="alert alert-success">{message}</div>}
            {error && <div className="alert alert-danger">{error}</div>}
            <button className="btn btn-block btn-success">Lagre</button>
        </form>
    )
}
export default AddDetail